// extracted by mini-css-extract-plugin
module.exports = {"info-panel-wrapper":"InfoPanel_info-panel-wrapper__1ZM9Z"};